import React, {useContext} from 'react';
import VehicleInventoryType, {
  getVehicleStatus,
} from '../Headline/VehicleInventoryType';
import {Breakpoints, TokenTextAppearance, styled} from '@volkswagen-onehub/components-core';
import { ResultsView, ResultsViewContext } from '../../../utils/results-view-context';
import { VehicleData } from '../../../types';
import { VehicleContext } from '../../../utils/vehicle-context';

interface CardStockContainerInterface {
  view: ResultsView;
}

const CardStockContainer = styled.div<CardStockContainerInterface>`
  grid-area: stock;
  margin-top: ${(props) => props.theme.size.static250};

  ${(props) =>
    props.view == ResultsView.LIST &&
    `
    @media screen and (min-width: ${Breakpoints.b960}px) {
      margin-left: 36px;
    }
  `}
`;

const CardStock: React.FC = () => {
  const view = useContext(ResultsViewContext).value;
  const vehicle = useContext(VehicleContext) as VehicleData;
  const vehicleStatus = getVehicleStatus(vehicle);
  const sold = vehicle.deleted;

  return (
    vehicle?.category
    ? <CardStockContainer view={view}>
        <VehicleInventoryType
          apperance={TokenTextAppearance.label100}
          category={vehicle.category}
          demo={vehicle.demo}
          vehicleStatus={vehicleStatus}
          sold={sold}
        />
      </CardStockContainer>
    : null
  );
};

export default CardStock;
